import cx from 'classnames'
import PropTypes from 'prop-types'

import FilterItemBasic, {filterItemBasicCheckElementTypes} from '@adv-mt/mt-filter-item-basic'

import {LIST_CLASS_NAME, LIST_ITEM_CLASS_NAME, LIST_ITEM_STICKY_CLASS_NAME} from '../../config.js'
import FilterBasicDefault from '../Default/index.js'
import useMultiSelectionNestedFilter from '../hooks/useMultiSelectionNestedFilter.js'

const FilterBasicMultiSelectionNested = ({
  allSelectionsId,
  allSelectionsLabel,
  isFullWidth,
  listItemDirection,
  onChange,
  options,
  value,
  withDivider
}) => {
  const {hasAllOptionsChecked, hasAllSelectionsField, onSelectAll, onSelectGroupItem, onSelectNestedItems} =
    useMultiSelectionNestedFilter({allSelectionsId, allSelectionsLabel, onChange, options, value})

  const baseClassNames = cx(LIST_CLASS_NAME, withDivider && `${LIST_CLASS_NAME}--withDivider`)

  const groupItemClassNames = cx(LIST_ITEM_CLASS_NAME, LIST_ITEM_STICKY_CLASS_NAME)

  return (
    <div className={baseClassNames}>
      {hasAllSelectionsField && (
        <li className={LIST_ITEM_CLASS_NAME}>
          <FilterItemBasic
            checkElementType={filterItemBasicCheckElementTypes.CHECKBOX}
            direction={listItemDirection}
            id={allSelectionsId}
            isBolder
            isFullWidth={isFullWidth}
            isSelected={hasAllOptionsChecked}
            label={allSelectionsLabel}
            onChange={onSelectAll}
          />
        </li>
      )}
      {options.map(({element, extendedInfo, icon, id, isIndeterminate, label, nestedItems}, index) => {
        const isGroupSelected = nestedItems.every(({id}) => value.includes(id))

        return (
          <>
            <li className={groupItemClassNames} key={`li-${id}-${index}`}>
              <FilterItemBasic
                checkElementType={filterItemBasicCheckElementTypes.CHECKBOX}
                direction={listItemDirection}
                element={element}
                extendedInfo={extendedInfo}
                icon={icon}
                id={id}
                isBolder
                isFullWidth={isFullWidth}
                isIndeterminate={isIndeterminate}
                isSelected={isGroupSelected}
                label={label}
                onChange={() => onSelectGroupItem({nestedItems})}
                tabIndex={index}
              />
            </li>
            <FilterBasicDefault
              checkElementType={filterItemBasicCheckElementTypes.CHECKBOX}
              isMultiSelect
              isNestedList
              listItemDirection={listItemDirection}
              onChange={onSelectNestedItems}
              options={nestedItems}
              value={value}
              withDivider={false}
            />
          </>
        )
      })}
    </div>
  )
}

FilterBasicMultiSelectionNested.displayName = 'FilterBasicMultiSelectionNested'
FilterBasicMultiSelectionNested.propTypes = {
  allSelectionsId: PropTypes.string,
  allSelectionsLabel: PropTypes.string,
  isFullWidth: PropTypes.bool,
  listItemDirection: PropTypes.string,
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      extendedInfo: PropTypes.string,
      icon: PropTypes.func,
      id: PropTypes.string.isRequired,
      isHighlighted: PropTypes.bool,
      label: PropTypes.string.isRequired,
      nestedItems: PropTypes.arrayOf(
        PropTypes.shape({
          extendedInfo: PropTypes.string,
          icon: PropTypes.node,
          id: PropTypes.string,
          isHighlighted: PropTypes.bool,
          label: PropTypes.string
        })
      )
    })
  ),
  value: PropTypes.array,
  withDivider: PropTypes.bool
}

export default FilterBasicMultiSelectionNested
